//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            brands : ['Toyota', 'Volkswagen', 'Fiat', 'Renault', 'Peugeot', 'Ford']
        }
    }
}
